import { useApiStore } from '@/stores/apiStore';

import { AppVersionApi } from '@/../generated-client/apis/AppVersionApi';
import {
  AppVersionOnAzure,
  AppVersionUpdate,
} from '../../generated-client/models';

let appVersionApi: AppVersionApi | null = null;
let lastConfig: unknown = null;

function getAppVersionApi(): AppVersionApi {
  const { apiConfig } = useApiStore.getState();

  // if config changed (token refresh), rebuild
  if (appVersionApi === null || lastConfig !== apiConfig) {
    appVersionApi = new AppVersionApi(apiConfig);
    lastConfig = apiConfig;
  }

  return appVersionApi;
}

export const updateAppVersion = async (appVersion: AppVersionUpdate) => {
  const api = getAppVersionApi();
  return await api.apiAppVersionUpdatePut({ appVersionUpdate: appVersion });
};

export const getAllByObjectType = async (objectType: string) => {
  const api = getAppVersionApi();
  return await api.apiAppVersionGetAllByObjectTypeGet({ objectType });
};

export const actuallyGetAllByObjectType = async (objectType: string) => {
  const api = getAppVersionApi();
  return await api.apiAppVersionActuallyGetAllByObjectTypeGet({ objectType });
};

export const getAllLiveByObject = async (objectType: string) => {
  const api = getAppVersionApi();
  return await api.apiAppVersionGetAllLiveByObjectTypeGet({
    objectType,
  });
};

export const deleteAppVersion = async (appVersion: AppVersionOnAzure) => {
  const jsonObject = {
    id: appVersion.id,
    object_type: appVersion.object_type,
  };
  const api = getAppVersionApi();
  return await api.apiAppVersionDeleteDelete({
    appVersionDelete: jsonObject,
  });
};

export const addAppVersion = async (appVersion: AppVersionOnAzure) => {
  const api = getAppVersionApi();
  return await api.apiAppVersionAddPost({
    appVersionCreate: appVersion,
  });
};
